import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { SideListOptionType } from '@fi-shared/types';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { IForumLightWeight } from '@fi-shared/fi-forum/fi-forum';

@Component({
    selector: 'fi-forum-post-add-container',
    template: `
        <div class="fi-container">
            <div class="fi-header">
                <div class="fi-header-actions">
                    <fi-button-back-new></fi-button-back-new>
                </div>
                <div class="fi-header-text">
                    {{ 'forum.new_discussion' | fiAppText }}
                </div>
            </div>
            <div class="fi-content">
                <fi-forum-post-add
                    [(forumId)]="forumId"
                    [availableForums]="availableForums"
                    (editCancelled)="onEditCancelled()"
                    (forumPostAdded)="onForumPostAdded()"
                ></fi-forum-post-add>
            </div>
        </div>
    `,
    styleUrls: ['./fi-forum-post-add-container.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-forum-post-add-container' },
    standalone: false,
})
export class FiForumPostAddContainerComponent {
    @Input() forumId: number;
    @Input() availableForums: IForumLightWeight[];

    constructor(private fiStateService: FiStateService) {}

    onEditCancelled() {
        window.history.back();
    }

    onForumPostAdded() {
        this.fiStateService.go(FiStateNames.Forum.View, {
            id: this.forumId,
            filterType: SideListOptionType.SharedWithMe,
        });
    }
}
